<app-loading-overlay [isLoading]="!!isLoading"></app-loading-overlay>
<div class="page-container">
  <div class="page-header">
    <div class="powerbi-container">
      <iframe [src]="powerBiUrl" width="100%" frameborder="0" allowFullScreen="true"> </iframe>
    </div>
  </div>
</div>
